<template>
  <div class="news-w">
    <img class="top-img" src="../../assets/img/news/news-t.png" alt="">
    <div class="new-tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="新闻资讯" name="first">
          <div v-show="list">
            <div class="news-one">
              <div class="news1-w" v-for="i in newsData2" :key="i.ID" @click="goDetail(i)">
                <img :src="i.img" >
                <div class="news-t">{{i.newTitle}}</div>
                <div class="news-time">{{i.newYear}}-{{i.newMonthDay}}</div>
              </div>
            </div>
            <!-- <div>{{newsData2[0].newContent}}</div> -->
            <div class="news-two" v-for="i in newsData" :key="i.ID"  @click="goDetail(i)">
              <div class="time">
                <div class="time-d">{{i.newMonthDay}}</div>
                <div class="time-y">{{i.newYear}}</div>
              </div>
              <div class="content">
                <div class="cont-t">{{i.newTitle}}</div>
                <!-- <div class="cont-c">{{i.newContent}}</div> -->
                <!-- <div class="cont-c"><p v-html="i.newContent"></p></div> -->
                <div class="cont-c"><p v-html="i.short"></p></div>
              </div>
              <div class="more"></div>
            </div>
          </div>
          <div v-show="!list" class="detail-w">
            <div class="dt-title">{{xq.newTitle}}</div>
            <div c class="dt-t">
              <div><i class="el-icon-date"></i> {{xq.newYear}}-{{xq.newMonthDay}}</div>
              <div><i class="el-icon-user"></i> {{xq.newAuthor}}</div>
            </div>
            <div class="line"></div>
            <!-- <div class="dt-c" v-html="xq.newContent"></div> -->
            <div class="dt-c">
              <div class="dt-cp" v-html="xq.newContent"></div>
              <img v-for="(i,k) in xq.img" :key="k" :src="i">
            </div>
            <div class="line"></div>
            <div class="goback" @click="golist"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'news',
  data () {
    return {
      activeName: 'first',
      list: true,
      xq: '',
      newsData: [
        {
          ID: 1,
          newTitle: '智赋城轨，绿色发展',
          newContent: '<p>&emsp;&emsp;我公司受邀参加 北京-青岛国际城市轨道交通展览会，北京-青岛国际城市轨道交通展览会暨高峰论坛于2023年4月27日-29日在青岛举办。</p><p>&emsp;&emsp;展会以“智赋城轨，绿色发展”为主题，携手超400家全球高质量展商，启用中铁·青岛世界博览城逾60000平方米的展示空间，创下展会规模历史新高；“13+N”辆多制式实车展示，创纪录全景展示装备强国底蕴。此次展会为期三天，展会采取“线上+线下”“展”“会”融合办展的模式，同期举办的论坛共计18场次，以“1+11+4+2”矩阵形式亮相——1场主论坛、11场分论坛、4场专题论坛和2场沙龙。</p><p>&emsp;&emsp;北京-青岛轨道展暨首届城轨高交会，集成果展示、技术推广、高峰论坛、发布签约、合作交流于一体，重点展示城市轨道交通领域先进的技术和产品、技术创新成果、科研成果，致力于为所有参与者创造交流展示机会、促进商机达成，是城轨行业贸易商务平台、新技术新产品展示发布平台、行业交流嘉年华、大众科普与互动的平台。</p>',
          newMonthDay: '04-27',
          newYear: '2023',
          newAuthor: 'xcp',
          short: '我公司受邀参加 北京-青岛国际城市轨道交通展览会，北京-青岛国际城市轨道交通展览会暨高峰论坛于2023年4月27日-29日在青岛举办。',
          img: [require('../../assets/img/news/new1.jpg'), require('../../assets/img/news/news2.jpg'), require('../../assets/img/news/news3.jpg')]
        },
        {
          ID: 2,
          newTitle: '安全保卫',
          newContent: '<p>&emsp;&emsp;恒安卫士具有先进的安检服务项目管理经验，优秀的管理团队，高素质的安检队伍，安检人员通过安检职业技能培训，持证上岗。</p><p>&emsp;&emsp;国际化、专业化、规范化、现代化的管理手段，标准化的管理体系，使恒安卫士在多年的安保管理服务工作中积累了丰富的经验，熟悉大型临时勤务的策划和执行、地铁安全检查的流程、市政基础设施的守卫、党政机关单位的值守、电力设施的巡视守护、群体性上访的处置等各个环节工作。</p>',
          newMonthDay: '09-08',
          newYear: '2020',
          newAuthor: 'xcp',
          short: '恒安卫士具有先进的安检服务项目管理经验，优秀的管理团队，高素质的安检队伍，安检人员通过安检职业技能培训，持证上岗。',
          img: [require('../../assets/img/news/x10.png')]
        },
        {
          ID: 3,
          newTitle: '轨道交通',
          img: [require('../../assets/img/index/x8.png')],
          newContent: '<p>&emsp;&emsp;地铁将成千上万的旅客从一个地方送到另一个地方，穿越高楼林立的城市和和车水马龙。如今，地铁运营商正致力于实现智能地铁运营技术，他们能做的不仅仅是保障乘客与设备的安全，更将全面分析潜在风险，以便在地铁安全、成本和运营效率方面提前实施预防性维护。</p>',
          newAuthor: 'xcp',
          short: '地铁将成千上万的旅客从一个地方送到另一个地方，穿越高楼林立的城市和和车水马龙。如今，地铁运营商正致力于实现智能地铁运营技术',
          newMonthDay: '09-08',
          newYear: '2020'
        },
        {
          ID: 4,
          newTitle: '智慧安检',
          img: [require('../../assets/img/index/x5.png')],
          newContent: '<p>&emsp;&emsp;我公司致力于开发智能安检的解决方案，致力于维持长期合作关系并提供可靠的平台解决方案，为全世界各地打造智慧安检平台。以累积多年经验，特别是在中国市场的经验，协助客户建置智慧安检解决方案，以及安全且轻巧的系统： 落实智慧开发与管理，例如 AI智能判图边缘计算、集中判图系统人包绑定、智慧安检门、大数据等多领 域技术的综合运用，研发出轨道交通智慧安检系统，实现轨道交通客户的减员增效，具备国际标准，全方位、全天候智能辅助守护城市安全</p>',
          newAuthor: 'xcp',
          short: '我公司致力于开发智能安检的解决方案，致力于维持长期合作关系并提供可靠的平台解决方案，为全世界各地打造智慧安检平台。',
          newMonthDay: '09-08',
          newYear: '2020'
        }
      ],
      newsData2: [
        {
          ID: 1,
          newTitle: '安全保卫',
          newContent: '<p>&emsp;&emsp;恒安卫士具有先进的安检服务项目管理经验，优秀的管理团队，高素质的安检队伍，安检人员通过安检职业技能培训，持证上岗。</p><p>&emsp;&emsp;国际化、专业化、规范化、现代化的管理手段，标准化的管理体系，使恒安卫士在多年的安保管理服务工作中积累了丰富的经验，熟悉大型临时勤务的策划和执行、地铁安全检查的流程、市政基础设施的守卫、党政机关单位的值守、电力设施的巡视守护、群体性上访的处置等各个环节工作。</p>',
          newMonthDay: '09-08',
          newYear: '2020',
          newAuthor: 'xcp',
          img: [require('../../assets/img/news/x10.png')]
        },
        {
          ID: '2',
          img: [require('../../assets/img/index/x8.png')],
          newContent: '<p>&emsp;&emsp;地铁将成千上万的旅客从一个地方送到另一个地方，穿越高楼林立的城市和和车水马龙。如今，地铁运营商正致力于实现智能地铁运营技术，他们能做的不仅仅是保障乘客与设备的安全，更将全面分析潜在风险，以便在地铁安全、成本和运营效率方面提前实施预防性维护。</p>',
          newAuthor: 'xcp',
          newTitle: '轨道交通',
          newMonthDay: '09-08',
          newYear: '2020'
        },
        {
          ID: '3',
          img: [require('../../assets/img/index/x5.png')],
          newContent: '<p>&emsp;&emsp;我公司专注于开发智能安检的解决方案，致力于维持长期合作关系并提供可靠的平台解决方案，为全世界各地打造智慧安检平台。以累积多年经验，特别是在中国市场的经验，协助客户建置智慧安检解决方案，以及安全且轻巧的系统： 落实智慧开发与管理，例如 AI智能判图边缘计算、集中判图系统人包绑定、智慧安检门、大数据等多领 域技术的综合运用，研发出轨道交通智慧安检系统，实现轨道交通客户的减员增效，具备国际标准，全方位、全天候智能辅助守护城市安全</p>',
          newAuthor: 'xcp',
          newTitle: '智慧安检',
          newMonthDay: '09-08',
          newYear: '2020'
        }
      ]
    }
  },
  created () {
    // this.getData()
  },
  methods: {
    goDetail (i) {
      this.list = false
      this.xq = i
      // this.xq.d = '恒安科技'
    },
    golist () {
      this.list = true
    },
    getData () {
      let _this = this
      axios.get('api/Backstage_New/ListTopThree').then(res => {
        if (res.status === 200) {
          _this.newsData = res.data.data.datas
          _this.newsData2 = res.data.data.datas.slice(0, 3)
          // eslint-disable-next-line no-useless-escape
          let reg = /<p>(.+?)*?<\/p>/
          // eslint-disable-next-line no-useless-escape
          let reg2 = /((https|http)?:\/\/)[^\s]+(jpg|png|jpeg|gif)/
          _this.newsData.forEach(item => {
            item.short = reg.exec(item.newContent)[0]
          })
          _this.newsData2.forEach(item => {
            if (reg2.test(item.newContent)) {
              item.img = reg2.exec(item.newContent)[0]
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.top-img{
  width: 100%;
  height: 400px;
}
.new-tabs{
  width: 1200px;
  height: auto;
  margin: 0 auto 100px;
}
.news-one{
  width: 100%;
  height: 365px;
  margin: 52px 0 60px;
  display: flex;
  justify-content: space-between;
}
.news1-w{
  width: 380px;
  height: 365px;
  border: 1px solid #EFEFEF;
}
.news1-w>img{
  width: 100%;
  height: 240px;
}
.news-t{
  width: 319px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  margin: 15px auto 10px;
}
.news-time{
  width: 319px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 30px;
  margin: 0 auto;
}
.news-two{
  width: 100%;
  height: 150px;
  padding-top: 50px;
  border-bottom: 1px solid #F7F7F7;
  display: flex;
  justify-content: space-between;
}
.time-d{
  width: 80px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #999999;
  line-height: 30px;
  margin-bottom: 10px;
}
.time-y{
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
}
.content{
  width: 880px;
}
.cont-t{
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #666666;
  line-height: 19px;
  cursor:pointer;
}
.cont-t:hover{
  color: #CC0000;
}
.cont-c{
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 19px;
  margin-top: 20px;
  overflow:hidden;white-space:nowrap;text-overflow:ellipsis;
}
.more{
  width: 25px;
  height: 23px;
  background: url('../../assets/img/news/more.png');
  background-size: 100%;
  cursor: pointer;
}
.detail-w{
  width: 100%;
  padding: 65px 0;
}
.dt-title{
  width: 100%;
  height: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  line-height: 24px;
  text-align: center;
}
.dt-t{
  width: 220px;
  height: 14px;
  margin: 40px auto 50px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.line{
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #F1F1F1;
}
.dt-c{
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  margin: 50px 0;
}
.dt-cp>p{
  font-size: 16px;
}
.dt-c>img{
  display: block;
  width: 900px;
  height: auto;
  margin: 60px auto;
}
.goback{
  float: right;
  width: 120px;
  height: 40px;
  background: url('../../assets/img/tech/btn-4.png');
  background-size: 100%;
  margin: 60px 0 0 1080px;
}
.goback:hover{
  background: url('../../assets/img/tech/btn-3.png');
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/news.vue